import * as THREE from './gt-three.js';
import {GLTFLoader} from './gt-gltf-loader.js';
const models=new Map();
function loadModel(url){if(!models.has(url))models.set(url,new GLTFLoader().loadAsync(url));return models.get(url);}

async function mountViewer(host) {
  if(host.dataset.modelState)return;
  host.dataset.modelState='loading';
  const status=host.querySelector('[data-luna-model-status]');
  const resetButton=host.querySelector('[data-reset-model]');
  try {
    const canvas=host.querySelector('canvas');
    const fallback=host.querySelector('.hero__model-fallback');
    const renderer=new THREE.WebGLRenderer({canvas,antialias:true,alpha:true,powerPreference:'low-power'});
    renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,1.75));
    renderer.setClearColor(0x000000,0);
    renderer.outputColorSpace=THREE.SRGBColorSpace;
    renderer.toneMapping=THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure=1.12;
    const scene=new THREE.Scene();
    scene.background=null;
    const camera=new THREE.PerspectiveCamera(34,1,.1,80);
    const gltf=await loadModel(host.dataset.modelSrc);
    if(!host.isConnected){renderer.dispose();return;}
    const source=gltf.scene.clone(true);
    source.updateMatrixWorld(true);
    const bounds=new THREE.Box3().setFromObject(source);
    const size=bounds.getSize(new THREE.Vector3());
    if(!Number.isFinite(size.y)||size.y<=0)throw new Error('Invalid model bounds');
    const center=bounds.getCenter(new THREE.Vector3());
    const modelScale=6.2/size.y;
    source.position.sub(center);
    const device=new THREE.Group();device.name='GlowTouch-Luna-supplied-GLB';
    device.scale.setScalar(modelScale);device.add(source);scene.add(device);
    const initialRotation=new THREE.Euler(.025,-.17,-.075);
    device.rotation.copy(initialRotation);
    scene.add(new THREE.HemisphereLight(0xffffff,0xaeb6aa,2.7));
    for(const [intensity,position] of [[3.4,[4,5,6]],[2.5,[-4,2,4]],[3.2,[1,3,-5]]]) {
      const light=new THREE.DirectionalLight(0xffffff,intensity);light.position.set(...position);scene.add(light);
    }
    const studio=new THREE.Scene();studio.background=new THREE.Color(0xb6b6b6);
    for(const [position,scale,intensity] of [[[0,4,0],[5,.2,6],4],[[4,0,1],[.2,6,4],3],[[-4,1,2],[.2,5,2],2.8],[[0,0,5],[2,6,.1],2]]) {
      const panel=new THREE.Mesh(new THREE.BoxGeometry(...scale),new THREE.MeshBasicMaterial({color:new THREE.Color().setScalar(intensity)}));
      panel.position.set(...position);studio.add(panel);
    }
    const pmrem=new THREE.PMREMGenerator(renderer);
    const environment=pmrem.fromScene(studio,.06);scene.environment=environment.texture;pmrem.dispose();
    studio.traverse(object=>{if(object.isMesh){object.geometry.dispose();object.material.dispose();}});
    let zoom=1,visible=true,frame=0,lost=false;
    let pinch=0;
    const pointers=new Map();
    const axisX=new THREE.Vector3(1,0,0),axisY=new THREE.Vector3(0,1,0),q=new THREE.Quaternion();
    function draw() {
      frame=0;
      if(lost||!visible||document.hidden)return;
      renderer.render(scene,camera);
    }
    function requestDraw(){if(!frame && !lost)frame=requestAnimationFrame(draw);}
    function resize() {
      const {width,height}=host.getBoundingClientRect();if(!width||!height)return;
      renderer.setSize(width,height,false);camera.aspect=width/height;
      camera.position.set(0,.08,(camera.aspect<.85?13.2:11.8)/zoom);
      camera.updateProjectionMatrix();requestDraw();
    }
    function setZoom(value){zoom=Math.max(.74,Math.min(1.85,value));resize();}
    function rotate(dx,dy){q.setFromAxisAngle(axisY,dx);device.quaternion.premultiply(q);q.setFromAxisAngle(axisX,dy);device.quaternion.premultiply(q);device.quaternion.normalize();requestDraw();}
    function reset(){device.rotation.copy(initialRotation);zoom=1;resize();}
    canvas.addEventListener('pointerdown',e=>{
      e.preventDefault();host.dataset.modelInput='pointer';if(document.activeElement===canvas)canvas.blur();canvas.setPointerCapture(e.pointerId);pointers.set(e.pointerId,[e.clientX,e.clientY]);pinch=0;
    });
    canvas.addEventListener('pointermove',e=>{
      if(!pointers.has(e.pointerId))return;
      const previous=pointers.get(e.pointerId);pointers.set(e.pointerId,[e.clientX,e.clientY]);
      if(pointers.size===2){const [a,b]=[...pointers.values()];const distance=Math.hypot(a[0]-b[0],a[1]-b[1]);if(pinch)setZoom(zoom*distance/pinch);pinch=distance;}
      else rotate((e.clientX-previous[0])*.009,(e.clientY-previous[1])*.009);
    });
    for(const event of ['pointerup','pointercancel','lostpointercapture'])canvas.addEventListener(event,e=>{pointers.delete(e.pointerId);pinch=0;});
    canvas.addEventListener('wheel',e=>{if(document.activeElement!==canvas&&!e.ctrlKey)return;e.preventDefault();setZoom(zoom*Math.exp(-e.deltaY*.001));},{passive:false});
    canvas.addEventListener('dblclick',reset);
    canvas.addEventListener('keydown',e=>{
      if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','+','=','-','0'].includes(e.key))return;
      e.preventDefault();
      if(e.key==='ArrowLeft')rotate(-.15,0);if(e.key==='ArrowRight')rotate(.15,0);if(e.key==='ArrowUp')rotate(0,-.15);if(e.key==='ArrowDown')rotate(0,.15);
      if(e.key==='+'||e.key==='=')setZoom(zoom+.1);if(e.key==='-')setZoom(zoom-.1);if(e.key==='0')reset();
    });
    resetButton.addEventListener('click',reset);
    document.addEventListener('keydown',event=>{if(event.key==='Tab')host.dataset.modelInput='keyboard';});
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)requestDraw();});
    if('IntersectionObserver' in window)new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)requestDraw();}).observe(host);
    if('ResizeObserver' in window)new ResizeObserver(resize).observe(host);else window.addEventListener('resize',resize);
    canvas.addEventListener('webglcontextlost',e=>{e.preventDefault();lost=true;cancelAnimationFrame(frame);fallback.hidden=false;host.dataset.modelState='error';status.textContent=status.dataset.errorText;resetButton.disabled=true;});
    resize();renderer.render(scene,camera);fallback.hidden=true;host.dataset.modelState='ready';status.textContent=status.dataset.readyText;resetButton.disabled=false;
    document.addEventListener('shopify:section:unload',event=>{if(!event.target.contains(host))return;lost=true;cancelAnimationFrame(frame);environment.dispose();renderer.dispose();},{once:true});
  } catch {
    host.dataset.modelState='error';
    host.querySelector('canvas').tabIndex=-1;
    host.querySelector('canvas').setAttribute('aria-hidden','true');
    host.querySelector('.hero__model-fallback').hidden=false;
    status.textContent=status.dataset.errorText;
    resetButton.disabled=true;
  }
}

function initialize(root=document){
  for(const host of root.querySelectorAll('[data-luna-model]')){
    if(host.dataset.modelState)continue;
    if('IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();mountViewer(host);}}, {rootMargin:'300px'});
      observer.observe(host);
    }else mountViewer(host);
  }
}
initialize();
document.addEventListener('shopify:section:load',event=>initialize(event.target));

